import { Button, Modal } from "react-bootstrap";

export function ConfirmProceedModal ({
  show,
  handleClose,
  title,
  triggerProceed,
  body,
  cancelarText = 'Cancelar',
  continuarText = 'Continuar'
}) {

  return <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {body || <>
        <p>¿Aún deseas continuar?</p>
      </>}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        {cancelarText}
      </Button>
      {triggerProceed && <Button variant="warning" onClick={triggerProceed}>
        {continuarText}
      </Button>}
    </Modal.Footer>
  </Modal>
}